import { CapacityItem, type CapacityItemProps } from './CapacityItem';

export interface CapacityProps {
	capacityData: Array<CapacityItemProps>;
}

/**
 * Capacity component displays a list of capacity information items
 *
 * @param capacityData - Array of capacity items containing type and title information
 * @returns JSX element with horizontally arranged capacity items
 *
 *
 * Possible errors:
 * - Empty capacityData array will render an empty container
 * - Invalid items in capacityData will be handled by CapacityItem component
 * - Duplicate titles should be avoided as they are used as React keys
 *
 * Exception handling:
 * - Gracefully handles empty or undefined capacityData
 * - Each CapacityItem handles its own error cases
 * - Uses title as key - ensure titles are unique within the array
 */
export const Capacity = ({ capacityData }: CapacityProps) => {
	if (!capacityData || capacityData.length === 0) {
		return null;
	}

	return (
		<div className="flex items-center justify-between grow-1">
			<div className="flex items-center gap-x-2">
				{capacityData.map((item, index) => (
					<CapacityItem
						key={`capacity-${index}`}
						type={item.type}
						title={item.title}
					/>
				))}
			</div>
		</div>
	);
};
